import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class CognitoServiceService {

  constructor(private http: HttpClient) { }

  public getTokenDetailsFromCognito(callbackCode: string): Observable<any> {
    const isInternal = !document.referrer.replace(/\/$/, "").toLowerCase().includes('saml') || document.referrer.replace(/\/$/, "") === environment.redirectURL
    const details: any = {
      grant_type: 'authorization_code',
      code: callbackCode,
      redirect_uri: environment.redirectURL,
      client_id: isInternal ? environment.sso_internal_client_id : environment.sso_external_client_id,
      scope: 'openid+profile'
    };

    const formBody = Object.keys(details)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(details[key as keyof typeof details])}`)
      .join('&');

    const cognitoTokenURL = isInternal ? environment.internalCognitoTokenURL : environment.externalCognitoTokenURL;

    sessionStorage.setItem('isInternal', isInternal.toString());

    return this.http.post<any>(cognitoTokenURL,
      formBody, {
      responseType: 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    }
    );
  }
}
